export default {
      id: "filter-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#filter-usage",
      toString: function () {
        return this.url;
      }
    }